import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5bd1758"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-flex flex-grow-0 flex-shrink-0 align-items-center justify-content-center relative" }
const _hoisted_2 = {
  key: 0,
  class: "tag-floating tag-copied fadeout animation-duration-3000 animation-iteration-1"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tag-floating tag-copy" }, "Copy", -1))

import { ref, computed } from 'vue';
import { UniqueComponentId } from 'primevue/utils';
import Icon from '@/components/Icon.vue';
import { ToastMessageOptions } from 'primevue/toast';
import { useToast } from 'primevue/usetoast';


export default /*#__PURE__*/_defineComponent({
  props: {
    data: null,
    color: null
  },
  setup(__props: any) {

const props = __props as {
  data: string;
  color?: string;
}


const toast = useToast();

const buttonId = UniqueComponentId();
const isTouch = computed(
  () => 'ontouchstart' in window || navigator.maxTouchPoints,
);
const isCopied = ref(false);
const tagHide = () => (isCopied.value = false);

const successCopyToClipboard = () => {
  isCopied.value = true;
  setTimeout(tagHide, 3500);
};
const showError = () => {
  toast.add({
    severity: 'danger',
    summary: 'Error',
    detail: 'Failed to copy data',
    life: 5000,
  } as ToastMessageOptions);
};

const fallback = () => {
  if (
    document.queryCommandSupported &&
    document.queryCommandSupported('copy')
  ) {
    const input = document.createElement('input');
    input.style.position = 'absolute';
    input.style.right = '9999px';
    input.setAttribute('readonly', 'true');
    document.getElementById(buttonId)?.appendChild(input);
    input.value = props.data;
    input.focus();
    input.select();
    try {
      successCopyToClipboard();
      return document.execCommand('copy');
    } catch (ex) {
      showError();
    } finally {
      document.getElementById(buttonId)?.removeChild(input);
    }
  }
};
const copyToClipboard = () => {
  if (!navigator.clipboard) {
    fallback();
    return;
  }
  navigator.clipboard
    .writeText(props.data)
    .then(() => {
      successCopyToClipboard();
    })
    .catch(() => {
      fallback();
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, {
      name: "copy",
      size: "20",
      onClick: copyToClipboard,
      class: _normalizeClass(["clickable copy-icon", [
        __props.color ? `text-${__props.color}` : '',
        { hoverable: !isCopied.value && !_unref(isTouch) },
      ]])
    }, null, 8, ["class"]),
    (isCopied.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Copied "))
      : _createCommentVNode("", true),
    _hoisted_3
  ]))
}
}

})